/**
 * FileUpload mixin
 * Used in Channel and VOD entity classes
 */

/**
 * FileUploadMixinFactory
 * returns FileUploadMixin mixin
 *
 * @class FileUploadMixinFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Object} {@link models.FileUploadMixin} mixin
 *
 * @ngdoc factory
 * @name mwApp.factory:FileUploadMixinFactory
 */
/* @ngInject */
export default function FileUploadMixinFactory (alertLiteSvc, $http) {
  /**
   * Mixin, allowing to upload files
   *
   * @mixin FileUploadMixin
   * @memberof models
   * @see models
   * @type {Object}
   */
  var FileUploadMixin = {

    /**
     * Upload file to the server<br>
     * {@link https://uncorkedstudios.com/blog/multipartformdata-file-upload-with-angularjs}
     *
     * @memberof models.FileUploadMixin#
     * @param {String} url
     * @param {File|Object}   file
     * @param {File}   file.value
     * @param {String}   file.param
     * @param {String}   file.fileName
     * @param {Object} [params] - additional request parameters
     * @return {Promise} promise
     */
    _uploadFile: function (url, file, params) {
      url = typeof url === 'string' ? url : 'api/upload'

      var fd = new window.FormData()
      if (file.hasOwnProperty('value') && file.hasOwnProperty('param')) {
        fd.append(file.param, file.value, file.fileName)
      } else {
        fd.append('file', file)
      }

      // append parameters, if any
      if (params) {
        for (let k in params) {
          if (params.hasOwnProperty(k)) {
            fd.append(k, params[k])
          }
        }
      }

      // upload image
      return $http.post(url, fd, {

        // Angular’s default transformRequest function will try to serialize FormData object,
        // so we override it with the identity function to leave the data intact
        transformRequest: angular.identity,

        // Angular’s default Content-Type header for POST and PUT requests is application/json,
        // so we want to change this, too.
        // By setting 'Content-Type': undefined, the browser sets the Content-Type to multipart/form-data
        // for us and fills in the correct boundary. Manually setting 'Content-Type': multipart/form-data
        // will fail to fill in the boundary parameter of the request.
        headers: {
          'Content-Type': undefined
        }
      }).catch(alertLiteSvc.alertError)
    },

    /**
     * Get preview image URL for given url and size
     * @param {String} url - исходный url (например, tabletBannerUrl)
     * @param {String} [size='210x118'] - размер превью
     * @return {String}
     */
    getPreviewImageUrl: function (url, size = '210x118') {
      if (!url) return ''
      if (url.indexOf('{{size}}') > -1) {
        return url.replace('{{size}}', size)
      }
      return url + (url.indexOf('?') === -1 ? `?resize=${size}` : `&resize=${size}`)
    }
  }

  return FileUploadMixin
}
